import React from "react";
import Button from "../../../common/Button";
import GrammarViewer from "../../../common/grammarViewer/GrammarViewer";

const Tip = ( props ) => {

  return (
    <div className="viewopen-detail on">
      <div className="popup_btnWrap">
        <Button className="btn_close" onClick={props.showTip}><span className="blind">닫기</span></Button>
      </div>
      <div className="viewopen-detail-inner">
        <div className="pvBox">
          <div className="pv-inner">
            <div className="pv-cont">
              <GrammarViewer>{ props.children }</GrammarViewer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

};

export default Tip;
